import script from "./ParticipationMixin.vue?vue&type=script&lang=js"
export * from "./ParticipationMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__